var login = {
  translation: {
    common: {
      accept: 'Accept',
      alreadyUser: 'Already a user?',
      and: 'and',
      backToLogin: 'Back to login page',
      continueWith: 'Continue with {{provider}}',
      createAccount: 'Create an account',
      createYourAccount: 'Create your account',
      emailOrUsername: 'Email or username',
      login: 'Login',
      logInToBoards: 'Log in',
      newToBoards: 'New to 4ga Boards?',
      pageNotFound_title: 'Page Not Found',
      password: 'Password',
      privacyPolicy: 'Privacy Policy',
      register: 'Register',
      registerWithGoogle: 'Register with Google',
      termsOfService: 'Terms of Service',
      togglePasswordVisibility: 'Toggle password visibility',
    },

    action: {
      logIn: 'Log in',
    },
  },
};

export { login as default };
